import { useBriefContext } from '../../../common/BriefContext';
import { BriefSection } from '../../../types';

export const useIncludeSection = () => {
    const { isBriefInEditMode, updateEditedBrief, setLastIncludedSectionId } = useBriefContext();

    return (section: BriefSection) => {
        if (!isBriefInEditMode) {
            updateEditedBrief(null, section.id, { included: true, focused: true });
            setLastIncludedSectionId(section.id);
            section.onAdd?.(section);
        }
    };
};
